import React, { forwardRef } from 'react';

const textareaStyle = {
    display: 'flex',
    minHeight: '80px',
    width: '100%',
    borderRadius: '0.375rem',
    border: '1px solid #e2e8f0', // slate-200
    backgroundColor: 'transparent',
    padding: '0.5rem 0.75rem',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    outline: 'none',
    transition: 'border-color 0.2s'
};

const Textarea = forwardRef(({ className, style, ...props }, ref) => {
    return (
        <textarea
            style={{ ...textareaStyle, ...style }}
            ref={ref}
            {...props}
        />
    );
});
Textarea.displayName = "Textarea";

export { Textarea };
